import ButtonLoadingSpinner from "./buttons/ButtonLoadingSpinner";

interface LoadingInlineProps {
  message: string;
}

export default function LoadingInline({message}:LoadingInlineProps) {
  return <div className="flex items-center"><ButtonLoadingSpinner color="text-gray-500" /><span className="text-gray-500">{message}</span></div>
}